/**
 * Deep-links from legacy KFS/BUR pages to the new unified grants module.
 *
 * Consumed by the ModuleMovedBanner on each legacy page and by the Sidebar
 * "(archiwum)" entries. Routing is type-preserving: legacy "Nabory" entries go
 * to the new CALLS module, legacy "Artykuły" entries go to the new ARTICLES
 * module — both filtered by scheme (env-agnostic, no hardcoded UUID).
 *
 * NOTE: the legacy in-page tables (KfsArticlesTable, BurArticlesTable) do NOT
 * use these — their row links intentionally point at the source article.
 */

/** New CALLS module filtered to the KFS scheme — target for legacy KFS "Nabory". */
export const KFS_CALLS_HREF = "/grants/calls?scheme=kfs";

/** New CALLS module filtered to the BUR scheme — target for legacy BUR "Nabory". */
export const BUR_CALLS_HREF = "/grants/calls?scheme=bur";

/** New ARTICLES module filtered to the KFS scheme — target for legacy KFS "Artykuły". */
export const KFS_ARTICLES_HREF = "/grants/articles?scheme=kfs";

/** New ARTICLES module filtered to the BUR scheme — target for legacy BUR "Artykuły". */
export const BUR_ARTICLES_HREF = "/grants/articles?scheme=bur";

/** Data freshness label shown in banners on legacy KFS pages. */
export const KFS_SNAPSHOT_LABEL = "Dane aktualne na: maj 2026";

/** Data freshness label shown in banners on legacy BUR pages. */
export const BUR_SNAPSHOT_LABEL = "Dane aktualne na: maj 2026";
